<div class="flyout box-flyout">
    <div class="chat-head chat-head-chatroom row no-gutters"></div>
    <div class="chat-body chatroom-body row no-gutters">
        <div class="disconnect-container hidden"></div>
    </div>
</div>
